import { isBefore } from 'date-fns';
import { Alert } from '../../../../../core/components/atoms/Alert';
import { Button } from '../../../../../core/components/atoms/Button';
import { Typography } from '../../../../../core/components/molecules/Typography';
import { LiveClass } from '../../../models/LiveClassDto.model';
import { AprovaLiveContentCard } from '../AprovaLiveContentCard';

interface iRecordedClassesListProps {
  items: LiveClass[];
  selectedEvent?: LiveClass;
  origin?: 'challenge' | 'live';
  showLoadMoreButton?: boolean;
  onClickLoadMore?: () => void;
  isLoadingMore?: boolean;
  onDone?: (id: string, slug: string) => void;
}

function RecordedClassesList({
  items,
  selectedEvent,
  origin,
  showLoadMoreButton = false,
  onClickLoadMore,
  isLoadingMore = false,
  onDone,
}: iRecordedClassesListProps) {
  const now = new Date();
  const isMarch2024 = now.getMonth() >= 2 && now.getFullYear() === 2024;
  const isBeforeStart = isBefore(now, new Date('2025-08-25'));

  if (origin === 'challenge' && isBeforeStart && items.length === 0) {
    return (
      <Alert
        variant='info'
        message={<Typography>A partir de 25 de agosto você confere todas as aulas gravadas do Desafio 60 dias aqui!</Typography>}
      />
    );
  }

  if (items.length === 0 && !isMarch2024) {
    return (
      <Alert
        variant='info'
        message={
          <Typography>
            A partir de <b>março</b> você confere todas as aulas gravadas do
            projeto AprovaLive aqui!
          </Typography>
        }
      />
    );
  }

  return (
    <ul className='flex flex-col gap-4'>
      {items.length === 0 && (
        <li className='flex justify-center p-4' key={`empty-list`}>
          <Typography variant='italic' size='small' className='text-center'>
            Nenhuma aula gravada encontrada
          </Typography>
        </li>
      )}

      {items.map((item, index) => {
        return (
          <AprovaLiveContentCard
            item={item}
            key={`recorded-class-${index}`}
            selected={selectedEvent && selectedEvent._id === item._id}
            origin={origin}
            onDone={onDone}
          />
        );
      })}

      {showLoadMoreButton && onClickLoadMore && (
        <li className='flex justify-center p-4' key={`load-more`}>
          <Button
            variant='text'
            onClick={onClickLoadMore}
            loading={isLoadingMore}
          >
            Carregar mais
          </Button>
        </li>
      )}
    </ul>
  );
}

export { RecordedClassesList };
